// Etiquetas de ordenes — fuente unica. Antes estos mapas estaban copiados en 7 archivos.

export const SHIPMENT_MODES = {
  not_specified: "Acuerdo con el vendedor",
  custom: "Envio Custom",
  me1: "Mercado Envíos 1",
  me2: "Mercado Envíos 2",
  self_service: "Mercado Envíos Flex",
};

/** Valor desconocido -> se muestra crudo, para que un modo nuevo no desaparezca de la grilla. */
export const translateShipmentMode = (mode) => {
  if (!mode) return "";
  return SHIPMENT_MODES[mode] || mode;
};

/** OJO: no coincide con MELI_SHIPMENT_STATUS — `cancelled` es "Rechazado" aca y "Cancelado" en el detalle. */
export const SHIPMENT_STATUS = {
  shipped: "En Viaje",
  delivered: "Entregado",
  cancelled: "Rechazado",
  not_delivered: "Con problemas en entrega",
  pending: "Pendiente",
};

export const translateStatus = (status) => {
  if (!status) return "";
  return SHIPMENT_STATUS[status] || status;
};

/** Estado del envio en el modal de detalle. */
export const MELI_SHIPMENT_STATUS = {
  to_be_agreed: "Acordado con el vendedor",
  pending: "Pendiente",
  handling: "Recibido",
  ready_to_ship: "Listo para enviar",
  shipped: "Enviado",
  delivered: "Entregado",
  not_delivered: "No Entregado",
  cancelled: "Cancelado",
};

export const translateStatusMeli = (status) => {
  if (!status) return "";
  return MELI_SHIPMENT_STATUS[status] || status;
};

/** `shipment_data.mode` de una orden Flex dice `me2`; lo que la distingue es `is_flex`, en la raiz. */
export const orderModeLabel = (order) => {
  if (!order) return "";
  if (order.is_flex) return SHIPMENT_MODES.self_service;
  return translateShipmentMode(order.shipment_data && order.shipment_data.mode);
};

/** El label ya viene traducido; el guion distingue "no informado" de "vacio". */
export const meliStatusLabel = (order) => {
  if (!order || !order.meli_status_label) return "—";
  return order.meli_status_label;
};

/** Lista de EXCLUSION: ML descarta en silencio los envios sin etiqueta, asi que hay que filtrar antes de pedir (§9.3). */
const LABEL_UNAVAILABLE = {
  pending: {
    tooltip: "Mercado Libre todavía no generó la etiqueta de este envío.",
    short: "Etiqueta todavía no generada",
  },
  handling: {
    tooltip: "Mercado Libre todavía no generó la etiqueta de este envío.",
    short: "Etiqueta todavía no generada",
  },
  ready_to_ship: {
    tooltip: "Mercado Libre todavía no generó la etiqueta de este envío.",
    short: "Etiqueta todavía no generada",
  },
  cancelled: {
    tooltip: "El envío está cancelado: no tiene etiqueta.",
    short: "Envío cancelado",
  },
};

/** Se lee `meli_status` (el codigo), nunca `meli_status_label`, que es solo para mostrar. */
const labelBlocker = (order) => (order && LABEL_UNAVAILABLE[order.meli_status]) || null;

export const hasLabelAvailable = (order) => !labelBlocker(order);

/** Texto largo, para el tooltip del boton deshabilitado. */
export const labelUnavailableTooltip = (order) => {
  const blocker = labelBlocker(order);
  return blocker ? blocker.tooltip : "";
};

/** Texto corto, para la lista de excluidas del dialogo del lote. */
export const labelUnavailableShort = (order) => {
  const blocker = labelBlocker(order);
  return blocker ? blocker.short : "";
};

/** Columna "Producto": titulo y cantidad del primer item, y cuantos mas trae la orden. */
export const productSummary = (order) => {
  const items = (order && order.order_items) || [];
  if (!items.length) return "—";
  const first = items[0] || {};
  const title = first.item && first.item.title;
  if (!title) return "—";
  const qty = first.quantity || 1;
  const resto = items.length > 1 ? ` +${items.length - 1}` : "";
  return `${title} \u00d7 ${qty}${resto}`;
};

/** Columna "Destino": localidad y provincia del destinatario. */
export const destinationLabel = (order) => {
  const addr =
    (order && order.shipment_data && order.shipment_data.receiver_address) || {};
  const city = (addr.city && addr.city.name) || "";
  const state = (addr.state && addr.state.name) || "";
  const partes = [city, state].filter(Boolean);
  return partes.length ? partes.join(", ") : "—";
};
